import { useGoogleOneTapLogin } from "@react-oauth/google";
import toast from "react-hot-toast";
import { useAuth } from "@/hooks/useAuth";
import useSocialLogin from "@/hooks/mutations/useSocialLogin";

export function GoogleOneTap() {
  const { user } = useAuth();
  const { mutateAsync } = useSocialLogin({ onSuccessReturnTo: false });

  useGoogleOneTapLogin({
    onSuccess: ({ credential }) => {
      mutateAsync({
        credential,
        providerId: 2,
        oneTapFlag: "is_google_one_tap",
      });
    },
    onError: () => {
      toast.success("One Tap prompt closed or failed to initialize");
    },
    // Dynamically disable the prompt if the user is already authenticated
    disabled: !!user,
    auto_select: true, // Seamlessly logs returning users back in
  });

  return null; // This component handles logic only, no visible UI elements
}
